export var FolioItemType;
(function (FolioItemType) {
    FolioItemType["ROOM_CHARGE"] = "ROOM_CHARGE";
    FolioItemType["FOOD_AND_BEVERAGE"] = "FOOD_AND_BEVERAGE";
    FolioItemType["SPA"] = "SPA";
    FolioItemType["PARKING"] = "PARKING";
    FolioItemType["TAX"] = "TAX";
    FolioItemType["DISCOUNT"] = "DISCOUNT";
    FolioItemType["OTHER"] = "OTHER";
    // Gratuity, e.g. posted by a signing
    FolioItemType["TIP"] = "TIP";
})(FolioItemType || (FolioItemType = {}));
export var ServicePricingType;
(function (ServicePricingType) {
    ServicePricingType["PER_NIGHT"] = "PER_NIGHT";
    ServicePricingType["PER_PERSON"] = "PER_PERSON";
    ServicePricingType["PER_PERSON_PER_NIGHT"] = "PER_PERSON_PER_NIGHT";
    ServicePricingType["PER_STAY"] = "PER_STAY";
    ServicePricingType["PER_USE"] = "PER_USE";
})(ServicePricingType || (ServicePricingType = {}));
